import axios from "axios";
import {clientGetWrapper, clientPostWrapper, clientPostWrapperWithOutTracking} from "../api/Api";
import {
    APPROVE_ALL_OR_REJECT_ALL_INFLUENCERS,
    DELETE_PAID_PROJECT,
    GET_ALL_PROJECTS, GET_PAID_PROJECT_INFLUENCERS, INSERT_NEW_INFLUENCER_RELATION,
    INSERT_NEW_PAID_PROJECTS,
    PAID_PROJECT_INFLUENCER_VIDEOS, PAID_PROJECT_INFLUENCER_VIDEOS_DELETE,
    PAID_PROJECT_INFLUENCER_VIDEOS_UPDATE, PAID_PROJECT_INFLUENCER_VIDEOS_UPLOAD_URL,
    UPDATE_PAID_PROJECT, UPDATE_PAID_PROJECT_INFLUENCER
} from "../common/constants/routes";


export const getAllPaidProjects = () => {
    return clientGetWrapper(GET_ALL_PROJECTS)
}

export const getSelectedProjectInfluencers = (projectId) => {
    return clientGetWrapper(GET_PAID_PROJECT_INFLUENCERS+ `?projectId=${projectId}`);
}
export const createPaidProject = (payload) => {
    return clientPostWrapper(INSERT_NEW_PAID_PROJECTS, payload)
}

export const addNewInfluencerPaidProject = (payload) => {
    return clientPostWrapper(INSERT_NEW_INFLUENCER_RELATION, payload)
}
export const updatePaidProject = (payload) => {
    return clientPostWrapper(UPDATE_PAID_PROJECT, payload)
}

export const changePaidProjectDisplayStatus = (payload) => {
    return clientPostWrapper(DELETE_PAID_PROJECT, payload)
}

export const updatePaidProjectInfuencer = (payload) => {
    return clientPostWrapper(UPDATE_PAID_PROJECT_INFLUENCER, payload)
}

export const approveOrRejectInfluencers = (payload) => {
    return clientPostWrapper(APPROVE_ALL_OR_REJECT_ALL_INFLUENCERS, payload)
}

export const getInfluencerVideos = (projectId, affId) =>
    clientGetWrapper(PAID_PROJECT_INFLUENCER_VIDEOS, {projectId, affId});

/** Raw file goes browser -> GCS via a signed PUT url (Cloud Run caps request bodies at 32MB),
 * then the server compresses it and inserts the row. Untracked: the card shows its own progress. */
export const uploadInfluencerVideo = async ({projectId, affId, file, comment, reelsUrl, onProgress}) => {
    const contentType = file.type || 'video/mp4';
    const {data: {uploadUrl, object}} = await clientPostWrapperWithOutTracking(
        PAID_PROJECT_INFLUENCER_VIDEOS_UPLOAD_URL, {projectId, affId, contentType});
    await axios.put(uploadUrl, file, {
        headers: {'Content-Type': contentType},
        onUploadProgress: (e) => e.total && onProgress?.(Math.round(e.loaded * 100 / e.total)),
    });
    onProgress?.(null); // upload done, server is compressing
    return clientPostWrapperWithOutTracking(PAID_PROJECT_INFLUENCER_VIDEOS,
        {projectId, affId, object, comment, reelsUrl});
};

export const updateInfluencerVideo = (payload) =>
    clientPostWrapper(PAID_PROJECT_INFLUENCER_VIDEOS_UPDATE, payload);

export const deleteInfluencerVideo = (id) =>
    clientPostWrapper(PAID_PROJECT_INFLUENCER_VIDEOS_DELETE, {id});
